import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleFilter, toggleSort } from '../../features/filter/filterSlice';

const Sidebar = () => {
    const dispatch = useDispatch();
    const {filter, sort:{type}} = useSelector((state) => state.filter)
    return (
        <aside>
        <div className="sidebar-items">
          <div className="sidebar-content">
            <h4>Sort</h4>
            <select
              name="sort"
              id="lws-sort"
              className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
              value={type}
              onChange={(e) => dispatch(toggleSort(e.target.value))}
            >
              <option value="default">Default</option>
              <option value="newest">Newest</option>
              <option value="most_liked">Most Liked</option>
            </select>
          </div>
          <div className="sidebar-content">
            <h4>Filter</h4>
            <div className="radio-group">
            {/*   <!-- handle filter on button click --> */}
              <div>
                <input
                  type="radio"
                  name="filter"
                  id="lws-all"
                  checked={filter === "All"}
                  className="radio"
                  onChange={() => dispatch(toggleFilter("All"))}
                />
                <label htmlFor="lws-all">All</label>
              </div>
              <div>
                <input
                  type="radio"
                  name="filter"
                  id="lws-saved"
                  checked={filter === "Saved"}
                  className="radio"
                  onChange={() => dispatch(toggleFilter("Saved"))}
                />
                <label htmlFor="lws-saved">Saved</label>
              </div>
            </div>
          </div>
        </div>
      </aside>
    );
};

export default Sidebar;